/**
 * @file landingPage.ts
 *
 * @fileoverview Contains helper functions for Landing page components.
 */
import { UserContextInterface } from '~/jobiqo/context/user';
import { checkUserConsentForService } from '~/jobiqo/services/cmp';
import { SERVICES } from '~/jobiqo/lib/cmp';

/**
 * Checks if the user has consented to the video service.
 *
 * @param {string} videoService
 *   The video service to check.
 * @param {UserContextInterface} userContext
 *   The user context.
 * @returns {boolean}
 *   True if the user has consented to the video service.
 */
export const checkVideoConsent = (
  videoService: string,
  userContext: UserContextInterface,
): boolean => {
  let consented = true;
  switch (videoService) {
    case 'youtube':
      consented = checkUserConsentForService(
        userContext?.consents,
        SERVICES.Youtube,
      );
      break;

    case 'vimeo':
      consented = checkUserConsentForService(
        userContext?.consents,
        SERVICES.Vimeo,
      );
      break;

    default:
      break;
  }
  return consented;
};

/**
 * Maps the video type to the service.
 *
 * @param {string} type
 *   The video type.
 * @returns {string}
 *   The service.
 */
export const mapVideoTypeToService = (type: string): string => {
  switch (type) {
    case 'youtube':
      return SERVICES.Youtube;
    case 'vimeo':
      return SERVICES.Vimeo;
    default:
      return '';
  }
};
